<div class="rejection-reasons">
	<tec-table [rows]="previewRows()" [config]="previewConfig" (rowEvent)="onRowClick($event)" />

	@if (hasMore() || previewRows().length > 0) {
		<div class="rejection-reasons__footer">
			<tec-link
				[label]="'PANEL.REJECTION_REASONS.VIEW_ALL' | translate"
				(click)="openViewAll()"
			/>
		</div>
	}
</div>

@if (viewAllOpen()) {
	<tec-modal
		[isVisible]="true"
		type="scrollable"
		[title]="'PANEL.REJECTION_REASONS.MODAL_TITLE' | translate"
		(closeEvent)="closeViewAll()"
	>
		<ng-container body>
			<p class="rejection-reasons__modal-description">
				{{ 'PANEL.REJECTION_REASONS.MODAL_DESCRIPTION' | translate }}
			</p>
			<tec-table
				[rows]="modalRows()"
				[headers]="modalHeader"
				[config]="modalConfig"
				(sortEvent)="sortChange($event)"
				(paginationChange)="paginationChange($event)"
				(rowEvent)="onRowClick($event)"
			/>
		</ng-container>
	</tec-modal>
}
